import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { money } from "utils/helpers";
import moment from "moment";
import DailyTransactionChart from "components/Charts/DailyTransactionChart";
import DatePicker from "components/Input/DatePicker";
import { useModal } from "utils/context/ModalContext";
import { TransactionService } from "services/TransactionService/TransactionService";
import { DashboardService } from "services/DashboardService/DashboardService";
import { FilterCard, MainBodyCard, PagesTitle } from "components/Cards";
import PrimaryButton from "components/Button/PrimaryButton";
import LocationIcon from "assets/icon/LocationIcon";

export default function StatisticReport(){
    let navigate = useNavigate()

    const { showLoading, hideLoading } = useModal()
    const { fetchDailyTransactionStatistic } = TransactionService()
    const { fetchDashboardInfo } = DashboardService()

    const [salesData, setSalesData] = useState([])
    const [expenseData, setExpenseData] = useState([])
    const [settlementData, setSettlementData] = useState([])
    const [salesVolumePerBank, setSalesVolumePerBank] = useState([])
    const [dailyTransactionMonth, setDailyTransactionMonth] = useState(moment(new Date()).format("M"))
    const [dailyTransactionYear, setDailyTransactionYear] = useState(moment(new Date()).format("yyyy"))
    const [dailyTransactionData, setDailyTransactionData] = useState([])

    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(new Date())

    const [totalTransfer, setTotalTransfer] = useState(0)
    const [totalExpense, setTotalExpense] = useState(0)
    const [transferAnjasmoro, setTransferAnjasmoro] = useState(0)
    const [transferTlogosari, setTransferTlogosari] = useState(0)
    const [totalCash, setTotalCash] = useState(0)
    const [cashAnjasmoro, setCashAnjasmoro] = useState(0)
    const [cashTlogosari, setCashTlogosari] = useState(0)
    const [cashIn, setCashIn] = useState(0)
    const [transferPL, setTransferPL] = useState(0)

    const previousDayClick = async () => {
        setDateFrom(moment(dateFrom).subtract(1, 'day'))
        setDateTo(moment(dateTo).subtract(1, 'day'))
    }
    const todayClick = async () => {
        setDateFrom(new Date())
        setDateTo(new Date())
    }
    const thisMonthClick = async () => {
        setDateFrom(moment(new Date()).startOf('month'))
        setDateTo(moment(new Date()).endOf('month'))
    }

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                const res = await fetchDashboardInfo(moment(dateFrom).format("YYYY-MM-DD"), moment(dateTo).format("YYYY-MM-DD"), moment(dateFrom).format("M"))
                if (!res) return

                let data = res.data

                setSalesData(data.salesData)
                setSettlementData(data.settlementData)
                setSalesVolumePerBank(data.salesVolumePerBank)
                setTransferAnjasmoro(data.transferAnjasmoro)
                setTransferTlogosari(data.transferTlogosari)
                setTotalTransfer(data.totalTransfer)
                setCashAnjasmoro(data.cashAnjasmoro)
                setCashTlogosari(data.cashTlogosari)
                setTotalCash(data.totalCash)
                setCashIn(data.cashIn)
                setTransferPL(data.transferPL)
                setExpenseData(data.expenseData)
                setTotalExpense(data.totalExpense)
            }
            finally {
                hideLoading()
            }
        }
        
        onLoad()
    },[dateFrom, dateTo])

    return(
        <MainBodyCard>
            <PagesTitle title='Dashboard' />

            <div className="flex gap-3 mt-3">
                <FilterCard title='Date From' width='w-full sm:w-56'>
                    <DatePicker className="bg-white h-10 w-full" value={dateFrom} onChange={(date) => setDateFrom(date)} />
                </FilterCard>

                <FilterCard title='Date To' width='w-full sm:w-56'>
                    <DatePicker className="bg-white h-10 w-full" value={dateTo} onChange={(date) => setDateTo(date)} />
                </FilterCard>

                <FilterCard title='' width='w-auto'>
                    <PrimaryButton title='H-1' onClick={previousDayClick} />
                </FilterCard>

                <FilterCard title='' width='w-auto'>
                    <PrimaryButton title='Hari ini' onClick={todayClick} />
                </FilterCard>

                <FilterCard title='' width='w-auto'>
                    <PrimaryButton title='Bulan ini' onClick={thisMonthClick} />
                </FilterCard>

            </div>

            <div className='flex flex-col xl:flex-row gap-5 mt-12'>
                <div className='bg-slate-100 p-4 rounded-lg border flex flex-col gap-2 w-full text-sm'>
                    <span className=''>TOTAL PROFIT</span>
                    <span className='text-2xl font-bold tracking-wide'>
                        Rp {Array.isArray(salesData)
                            ? money(salesData.reduce((sum, item) => sum + (parseInt(item.totalProfit) || 0), 0))
                            : 0}
                    </span>
                </div>
                
                <div className='bg-slate-100 p-4 rounded-lg border flex flex-col gap-2 w-full text-sm'>
                    <span className=''>TOTAL PENGELUARAN</span>
                    <span className='text-2xl font-bold tracking-wide'>
                        Rp {money(totalExpense)}
                    </span>
                </div>

                <div className='bg-slate-100 p-4 rounded-lg border flex flex-col gap-2 w-full text-sm'>
                    <span className=''>NETT PROFIT</span>
                    <span className='text-2xl font-bold tracking-wide'>
                        Rp {Array.isArray(salesData)
                            ? money(salesData.reduce((sum, item) => sum + (parseInt(item.totalProfit) || 0), 0) - totalExpense)
                            : 0}
                    </span>
                </div>
                
            </div>

            <div className='flex flex-col xl:flex-row gap-5 mt-12'>
                <div className='bg-slate-100 p-4 rounded-lg border flex flex-col gap-2 w-full text-sm'>
                    <span className=''>TOTAL TRANSAKSI</span>
                    <span className='text-2xl font-bold tracking-wide'>
                        Rp {Array.isArray(salesData)
                        ? money(salesData.reduce((sum, item) => sum + (parseInt(item.totalSales) || 0), 0))
                        : 0}
                    </span>
                    <div className='flex justify-between'>
                        <span>Total Profit</span>
                        <span className=''>
                            Rp {Array.isArray(salesData)
                            ? money(salesData.reduce((sum, item) => sum + (parseInt(item.totalProfit) || 0), 0))
                            : 0}
                        </span>
                    </div>
                </div>

                <div className='flex gap-4'>
                    {salesData?.map((item, i) => {
                        return(
                            <div key={i} className='bg-slate-100 p-4 rounded-lg border flex flex-col gap-2 w-full xl:w-72'>
                                <div className="flex gap-3 items-center">
                                    <LocationIcon />
                                    <span className='text-sm'>                                        
                                        {item.locationName.toUpperCase()}
                                    </span>
                                </div>
                                
                                <span className='text-2xl font-bold tracking-wide'>
                                    Rp {money(parseInt(item.totalSales) || 0)}
                                </span>
                                {/* <div className="flex justify-between">
                                    <span>Uang diterima</span>
                                    <span>Rp {money(parseInt(item.totalNetto) || 0)}</span>   
                                </div> */}
                                <div className="flex justify-between">
                                    <span>Profit</span>
                                    <span>Rp {money(parseInt(item.totalProfit) || 0)}</span>   
                                </div>
                            </div>    
                        )
                    })}
                </div>
            </div>

            <div className='flex gap-5 mt-3'>
                <div className='bg-slate-200 p-4 rounded-lg border flex flex-col gap-2 w-full'>
                    <span className='text-sm'>TOTAL PELUNASAN</span>
                    <span className='text-2xl font-bold tracking-wide'>
                        Rp {Array.isArray(settlementData)
                        ? money(settlementData.reduce((sum, item) => sum + (parseInt(item.totalSettlement) || 0), 0))
                        : 0}
                    </span>
                </div>

                <div className='flex gap-4'>
                    {settlementData?.map((item, i) => {
                        return(
                            <div key={i} className='bg-slate-200 p-4 rounded-lg border flex flex-col gap-2 w-full xl:w-72'>
                                <span className='text-sm'>PELUNASAN {item.locationName.toUpperCase()}</span>
                                <span className='text-2xl font-bold tracking-wide'>
                                    Rp {money(parseInt(item.totalSettlement) || 0)}
                                </span>
                            </div>    
                        )
                    })}
                </div>
            </div>

            <div className='flex gap-5 mt-3'>
                <div className='bg-slate-300 p-4 rounded-lg border flex flex-col gap-2 w-full'>
                    <span className='text-sm'>TOTAL TRANSFER</span>
                    <span className='text-2xl font-bold tracking-wide'>
                        Rp {money(parseInt(totalTransfer) || 0)}
                    </span>
                    {/* <div className="flex justify-between">
                        <span>ANJASMORO</span>
                        <span>Rp {money(parseInt(transferAnjasmoro) || 0)}</span>   
                    </div>
                    <div className="flex justify-between">
                        <span>TLOGOSARI</span>
                        <span>Rp {money(parseInt(transferTlogosari) || 0)}</span>   
                    </div> */}
                </div>

                <div className='flex w-full'>
                    <div className='bg-slate-300 p-4 rounded-lg border flex flex-col gap-2 w-full'>
                        <span className='text-sm'>TOTAL CASH/TUNAI</span>
                        <span className='text-2xl font-bold tracking-wide'>
                            Rp {money(parseInt(totalCash) || 0)}
                        </span>
                    </div>
                </div>
            </div>

            <div className='flex flex-col xl:flex-row gap-5 mt-12'>
                <div className='bg-slate-100 p-4 rounded-lg border flex flex-col gap-2 w-full text-sm'>
                    <span className=''>TOTAL PENGELUARAN</span>
                    <span className='text-2xl font-bold tracking-wide'>
                        Rp {money(totalExpense)}
                    </span>
                </div>

                <div className='flex gap-4'>
                    {expenseData?.map((item, i) => {
                        return(
                            <div key={i} className='bg-slate-100 p-4 rounded-lg border flex flex-col gap-2 w-full xl:w-72'>
                                <div className="flex gap-3 items-center">
                                    <LocationIcon />
                                    <span className='text-sm'>                                        
                                        {item.locationName.toUpperCase()}
                                    </span>
                                </div>
                                
                                <span className='text-2xl font-bold tracking-wide'>
                                    Rp {money(parseInt(item.totalAmount) || 0)}
                                </span>
                            </div>    
                        )
                    })}
                </div>
            </div>

            <div className="mt-12">
                <span className="text-xl font-semibold">Sales Volume (Bank)</span>
            </div>
            
            <div className='flex flex-col xl:flex-row gap-5 mt-3'>    
                <div className='flex flex-wrap gap-4'>
                    {salesVolumePerBank?.map((item, i) => {
                        return(
                            <div key={i} className='bg-slate-100 p-4 rounded-lg border flex flex-col gap-2 w-full xl:w-72'>
                                <div className="flex flex-col">
                                    <span className='text-sm'>                                        
                                        {item.bankCode.toUpperCase()} - {item.bankName.toUpperCase()}
                                    </span>
                                    <span className='text-sm'>                                        
                                        {item.type.toUpperCase()}
                                    </span>
                                </div>
                                
                                <span className='text-2xl font-bold tracking-wide'>
                                    Rp {money(parseInt(item.salesAmount) || 0)}
                                </span>
                            </div>    
                        )
                    })}
                </div>
            </div>
        </MainBodyCard>
    )
}